// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nYM1a{background-color:unset!important;color:#0009!important}.nYM1a:focus,.nYM1a:hover{background-color:#dededf!important;color:#0009!important}.ntsmz{background-color:unset!important;box-shadow:none!important;color:#fff!important}.ntsmz:focus,.ntsmz:hover{background-color:#2f3335!important;color:#fff!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `nYM1a`,
	"dark": `ntsmz`
};
module.exports = ___CSS_LOADER_EXPORT___;
